// 60 animal theme characters. Each drives the app's accent theme.
// c = primary hex color used for --primary
export const ANIMALS = [
  // Hewan Lucu (12)
  { key: "koala", name: "Koala", emoji: "\uD83D\uDC28", cat: "Hewan Lucu", c: "#8b9dc3" },
  { key: "hamster", name: "Hamster", emoji: "\uD83D\uDC39", cat: "Hewan Lucu", c: "#e6a57e" },
  { key: "kelinci", name: "Kelinci", emoji: "\uD83D\uDC30", cat: "Hewan Lucu", c: "#f2a1c2" },
  { key: "panda", name: "Panda", emoji: "\uD83D\uDC3C", cat: "Hewan Lucu", c: "#4b5563" },
  { key: "kucing", name: "Kucing", emoji: "\uD83D\uDC31", cat: "Hewan Lucu", c: "#d9a066" },
  { key: "anjing", name: "Anjing", emoji: "\uD83D\uDC36", cat: "Hewan Lucu", c: "#c89b6c" },
  { key: "rubah", name: "Rubah", emoji: "\uD83E\uDD8A", cat: "Hewan Lucu", c: "#e8722c" },
  { key: "tupai", name: "Tupai", emoji: "\uD83D\uDC3F\uFE0F", cat: "Hewan Lucu", c: "#b5651d" },
  { key: "landak", name: "Landak", emoji: "\uD83E\uDD94", cat: "Hewan Lucu", c: "#a07850" },
  { key: "berang", name: "Berang-berang", emoji: "\uD83E\uDDA6", cat: "Hewan Lucu", c: "#7a5c3e" },
  { key: "domba", name: "Domba", emoji: "\uD83D\uDC11", cat: "Hewan Lucu", c: "#cbb8a9" },
  { key: "sapi", name: "Sapi", emoji: "\uD83D\uDC2E", cat: "Hewan Lucu", c: "#9a8478" },
  // Hewan Buas (12)
  { key: "harimau", name: "Harimau", emoji: "\uD83D\uDC2F", cat: "Hewan Buas", c: "#FF7A00" },
  { key: "singa", name: "Singa", emoji: "\uD83E\uDD81", cat: "Hewan Buas", c: "#d99a2b" },
  { key: "serigala", name: "Serigala", emoji: "\uD83D\uDC3A", cat: "Hewan Buas", c: "#6b7280" },
  { key: "beruang", name: "Beruang", emoji: "\uD83D\uDC3B", cat: "Hewan Buas", c: "#7b5230" },
  { key: "macan", name: "Macan Tutul", emoji: "\uD83D\uDC06", cat: "Hewan Buas", c: "#c78a3b" },
  { key: "buaya", name: "Buaya", emoji: "\uD83D\uDC0A", cat: "Hewan Buas", c: "#4b7a3f" },
  { key: "gajah", name: "Gajah", emoji: "\uD83D\uDC18", cat: "Hewan Buas", c: "#8a8d91" },
  { key: "badak", name: "Badak", emoji: "\uD83E\uDD8F", cat: "Hewan Buas", c: "#787c80" },
  { key: "gorila", name: "Gorila", emoji: "\uD83E\uDD8D", cat: "Hewan Buas", c: "#3f4448" },
  { key: "hiu", name: "Hiu", emoji: "\uD83E\uDD88", cat: "Hewan Buas", c: "#3a7ca5" },
  { key: "kudanil", name: "Kuda Nil", emoji: "\uD83E\uDD9B", cat: "Hewan Buas", c: "#9d7d8a" },
  { key: "zebra", name: "Zebra", emoji: "\uD83E\uDD93", cat: "Hewan Buas", c: "#5c6066" },
  // Burung (12)
  { key: "merak", name: "Merak", emoji: "\uD83E\uDD9A", cat: "Burung", c: "#0f9b8e" },
  { key: "elang", name: "Elang", emoji: "\uD83E\uDD85", cat: "Burung", c: "#8b5e3c" },
  { key: "burunghantu", name: "Burung Hantu", emoji: "\uD83E\uDD89", cat: "Burung", c: "#9c6b3f" },
  { key: "penguin", name: "Penguin", emoji: "\uD83D\uDC27", cat: "Burung", c: "#37474f" },
  { key: "beo", name: "Beo", emoji: "\uD83E\uDD9C", cat: "Burung", c: "#28a745" },
  { key: "ayam", name: "Ayam", emoji: "\uD83D\uDC13", cat: "Burung", c: "#c0392b" },
  { key: "bebek", name: "Bebek", emoji: "\uD83E\uDD86", cat: "Burung", c: "#d4a017" },
  { key: "angsa", name: "Angsa", emoji: "\uD83E\uDDA2", cat: "Burung", c: "#b0a7a0" },
  { key: "flamingo", name: "Flamingo", emoji: "\uD83E\uDDA9", cat: "Burung", c: "#f06595" },
  { key: "merpati", name: "Merpati", emoji: "\uD83D\uDD4A\uFE0F", cat: "Burung", c: "#9aa5b1" },
  { key: "kolibri", name: "Kolibri", emoji: "\uD83D\uDC26", cat: "Burung", c: "#1abc9c" },
  { key: "kalkun", name: "Kalkun", emoji: "\uD83E\uDD83", cat: "Burung", c: "#a0522d" },
  // Serangga (12)
  { key: "kupu", name: "Kupu-kupu", emoji: "\uD83E\uDD8B", cat: "Serangga", c: "#9b59b6" },
  { key: "lebah", name: "Lebah", emoji: "\uD83D\uDC1D", cat: "Serangga", c: "#f1c40f" },
  { key: "kepik", name: "Kepik", emoji: "\uD83D\uDC1E", cat: "Serangga", c: "#e74c3c" },
  { key: "semut", name: "Semut", emoji: "\uD83D\uDC1C", cat: "Serangga", c: "#6d4c41" },
  { key: "capung", name: "Capung", emoji: "\uD83E\uDEB0", cat: "Serangga", c: "#16a085" },
  { key: "belalang", name: "Belalang", emoji: "\uD83E\uDD97", cat: "Serangga", c: "#7cb342" },
  { key: "jangkrik", name: "Jangkrik", emoji: "\uD83E\uDD97", cat: "Serangga", c: "#558b2f" },
  { key: "nyamuk", name: "Nyamuk", emoji: "\uD83E\uDD9F", cat: "Serangga", c: "#795548" },
  { key: "lalat", name: "Lalat", emoji: "\uD83E\uDEB0", cat: "Serangga", c: "#607d8b" },
  { key: "kalajengking", name: "Kalajengking", emoji: "\uD83E\uDD82", cat: "Serangga", c: "#c1440e" },
  { key: "labalaba", name: "Laba-laba", emoji: "\uD83D\uDD77\uFE0F", cat: "Serangga", c: "#455a64" },
  { key: "siput", name: "Siput", emoji: "\uD83D\uDC0C", cat: "Serangga", c: "#8d6e63" },
  // Ikan (12)
  { key: "ikan", name: "Ikan", emoji: "\uD83D\uDC1F", cat: "Ikan", c: "#2980b9" },
  { key: "ikantropis", name: "Ikan Tropis", emoji: "\uD83D\uDC20", cat: "Ikan", c: "#f39c12" },
  { key: "buntal", name: "Ikan Buntal", emoji: "\uD83D\uDC21", cat: "Ikan", c: "#e67e22" },
  { key: "lumba", name: "Lumba-lumba", emoji: "\uD83D\uDC2C", cat: "Ikan", c: "#3498db" },
  { key: "paus", name: "Paus", emoji: "\uD83D\uDC33", cat: "Ikan", c: "#2c5f8a" },
  { key: "hiuputih", name: "Hiu Putih", emoji: "\uD83E\uDD88", cat: "Ikan", c: "#5d8aa8" },
  { key: "gurita", name: "Gurita", emoji: "\uD83D\uDC19", cat: "Ikan", c: "#c0399b" },
  { key: "cumi", name: "Cumi-cumi", emoji: "\uD83E\uDD91", cat: "Ikan", c: "#d16ba5" },
  { key: "udang", name: "Udang", emoji: "\uD83E\uDD90", cat: "Ikan", c: "#ff7e67" },
  { key: "kepiting", name: "Kepiting", emoji: "\uD83E\uDD80", cat: "Ikan", c: "#e74c3c" },
  { key: "lobster", name: "Lobster", emoji: "\uD83E\uDD9E", cat: "Ikan", c: "#cc3333" },
  { key: "ubur", name: "Ubur-ubur", emoji: "\uD83E\uDEBC", cat: "Ikan", c: "#a29bfe" },
];

export function getAnimal(key) {
  return ANIMALS.find((a) => a.key === key) || ANIMALS[0];
}

export const ANIMAL_CATS = ["Hewan Lucu", "Hewan Buas", "Burung", "Serangga", "Ikan"];
